import { createClient } from '@supabase/supabase-js';
import { readStoredErpSession } from './erpSessionStorage';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase env eksik. VITE_SUPABASE_URL ve VITE_SUPABASE_ANON_KEY degerlerini kontrol edin.');
}

const fetchWithErpSession = async (input, init = {}) => {
  const headers = new Headers(init?.headers || {});
  const session = readStoredErpSession();

  if (session?.session_token) {
    headers.set('x-erp-session', session.session_token);
  }

  return fetch(input, {
    ...init,
    headers
  });
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: {
    fetch: fetchWithErpSession
  }
});
